export default "__VITE_ASSET__CRMf00RI__"